<template>
  <v-app style="background: #f8fafc">
    <TopNavbar v-if="showNavbar" />
    <v-main>
      <router-view />
    </v-main>
    <GlobalLoader />
  </v-app>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import TopNavbar from "@/components/layouts/TopNavbar.vue";
import GlobalLoader from "@/components/globalComp/GlobalLoader.vue";
import { useAuthStore } from "@/stores/auth";

const route = useRoute();
const auth = useAuthStore();

const showNavbar = computed(() => {
  return auth.isAuthenticated && route.path !== "/login";
});
</script>
<style></style>
